export var LayoutVariant;
!function (e) {
  e.STACKED = "stacked", e.THREE_PANEL = "three-panel";
}(LayoutVariant || (LayoutVariant = {}));
export var AnalyticsEventType;
!function (e) {
  e.CodeSampleLanguageSwitched = "CodeSampleLanguageSwitched", e.CodeSampleCopied = "CodeSampleCopied", e.OperationServerExpanded = "OperationServerExpanded", e.PanelToggle = "PanelToggle", e.TryItOpen = "TryItOpen", e.TryItSent = "TryItSent";
}(AnalyticsEventType || (AnalyticsEventType = {}));